import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { device, fontSize, space, color } from '@ticketswap/solar'
import { CalendarClock } from '@ticketswap/comets'
import { useLanguage } from '~/components/LanguageContext'
import { getDateTimeString } from '~/utils/event'
import { Pin } from '@ticketswap/comets'
import Link from 'next/link'
import { getLinkProps } from '~/utils'
import { decodeGlobalId } from '~/utils/id'

const Container = styled.div`
  @media ${device.tablet} {
    display: flex;
  }
`

const Item = styled.div`
  align-items: flex-start;
  display: flex;
  margin: ${space[4]} 0;
  color: ${color.nova};
  hyphens: none;
  font-size: ${fontSize[16]};

  [data-theme='dark'] & {
    color: ${color.space};
  }

  a {
    color: ${color.nova};

    [data-theme='dark'] & {
      color: ${color.space};
    }
  }

  @media ${device.tablet} {
    max-width: ${272 / 16}rem;
    margin: ${space[8]} 0;
    padding-right: ${space[24]};
  }
`

const IconWrapper = styled.span`
  display: inline-block;
  margin-right: ${space[8]};
  transform: translateY(-2px);
`

const EventMeta = ({ t, location, ...props }) => {
  const language = useLanguage()

  return (
    <Container {...props}>
      <Item>
        <IconWrapper>
          <CalendarClock size={20} />
        </IconWrapper>
        {getDateTimeString(props, language)}
      </Item>
      {location && (
        <Item>
          <IconWrapper>
            <Pin size={20} />
          </IconWrapper>
          <span>
            <Link
              {...getLinkProps('LOCATION', {
                slug: location.slug,
                id: decodeGlobalId(location.id),
              })}
            >
              <a>{location.name}</a>
            </Link>
            {location.city && (
              <>
                {', '}
                <Link
                  {...getLinkProps('CITY', {
                    slug: location.city.slug,
                    id: decodeGlobalId(location.city.id),
                  })}
                >
                  <a>{location.city.name}</a>
                </Link>
              </>
            )}
            {location.country && `, ${location.country.name}`}
          </span>
        </Item>
      )}
    </Container>
  )
}

EventMeta.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  location: PropTypes.shape({
    city: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      slug: PropTypes.string,
    }),
    country: PropTypes.shape({
      name: PropTypes.string,
    }),
    id: PropTypes.string,
    name: PropTypes.string,
    slig: PropTypes.string,
  }),
}

export default EventMeta
